import type { ReactNode } from 'react';
import { cx } from './cx';

/** govuk/components/inset-text */
export function InsetText({ id, className, lang, children }: { id?: string; className?: string; lang?: string; children: ReactNode }) {
  return (
    <div id={id} className={cx('govuk-inset-text', className)} lang={lang}>
      {children}
    </div>
  );
}
